const colorSet = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
    'rgba(121, 227, 237, 1)',
    'rgba(204, 111, 235, 1)',
    'rgba(188, 235, 102, 1)',
    'rgba(236, 236, 236, 1)',
    'rgba(189, 195, 199, 1)',
    'rgba(138, 152, 147, 1)',
]

const transparentSet = [
    'rgba(255, 99, 132, 0.2)',
    'rgba(54, 162, 235, 0.2)',
    'rgba(255, 206, 86, 0.2)',
    'rgba(75, 192, 192, 0.2)',
    'rgba(153, 102, 255, 0.2)',
    'rgba(255, 159, 64, 0.2)',
    'rgba(121, 227, 237, 0.2)',
    'rgba(204, 111, 235, 0.2)',
    'rgba(188, 235, 102, 0.2)',
    'rgba(236, 236, 236, 0.2)',
    'rgba(189, 195, 199, 0.2)',
    'rgba(138, 152, 147, 0.2)',
]

export {transparentSet};
export default colorSet; 